module.exports = __webpack_public_path__ + "img/success.b3f164a7.png";